import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import SampleProfiles from '../components/home/SampleProfiles';

const BrowsePage = () => {
  return (
    <div className="py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
        <h1 className="font-heading font-bold text-2xl sm:text-3xl text-white mb-2">
          Hire a Friend
        </h1>
        <p className="text-slate-400 mb-6">
          Browse and hire the right friend for your mood or need. Filter by gender, age, location,
          language, and type of friend.
        </p>
        <div className="p-6 rounded-2xl bg-slate-800/80 border border-amber-500/40 flex items-center justify-between flex-wrap gap-4">
          <p className="text-amber-200 font-medium">
            Want to view more? Unlock full access for ₹1,000 (one-time only)
          </p>
          <Link
            to="/register?role=user"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-brand-pink text-white font-semibold hover:bg-brand-pink-dark"
          >
            <Lock className="h-4 w-4" />
            Unlock for ₹1000
          </Link>
        </div>
      </div>
      <SampleProfiles />
    </div>
  );
};

export default BrowsePage;
